import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button} from "@chakra-ui/react";
import Sheet, {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useNotes} from "../../../api/moderation";
import useModal from "../../../modals";
import {useRelativeTimeFormatter} from "../../../store";
import CreateNoteSheet from "./create_note";
import {themecolors} from "../../../utils/themecolors";

const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;
const NoNotes = styled.div`
  text-align: center;
`;
const Author = styled.div`
  font-weight: 500;`;
const Ago = styled.div`
  margin-left: auto;
  font-size: 15px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};`;
const Details = styled.div`
  display: flex;
  margin-bottom: 4px;`;
const Scroll = styled.div`
  max-height: 300px;
  overflow: scroll;
`;

const ViewNotesSheet = styled(({className, username, community, onClose}) => {

        const {feedbackCh} = useFeedback();
        const modal = useModal();
        const formatRelativeTime = useRelativeTimeFormatter();
        const notes = useNotes(feedbackCh, username, community);

        const [addNoteOpen, setAddNoteOpen] = useState(false);
        const handleNewNote = () => {
            setAddNoteOpen(true);
        };

        return (
            <div className={className}>

                <Header>
                    <Title>Notes</Title>
                </Header>

                <Scroll>
                    {notes?.length === 0 && <NoNotes>No notes yet.</NoNotes>}
                    {notes?.map((note) => (
                        <Item key={note.id}>
                            <Details>
                                <Author>{note.author}</Author>
                                <Ago>{formatRelativeTime(note.created)}</Ago>
                            </Details>
                            <p>{note.note}</p>
                        </Item>
                    ))}
                </Scroll>

                <Button variant={"grey"} style={{width: '100%', marginTop: '24px'}} onClick={handleNewNote}>Create Note</Button>

                {addNoteOpen && <Sheet onClose={() => setAddNoteOpen(false) } padding={"header"}><CreateNoteSheet community={community} username={username} onClose={() => onClose() } /></Sheet>}

            </div>
        );
    }
)`
`;

export default ViewNotesSheet;
